import { render, staticRenderFns } from "./ingredientBreakdown.vue?vue&type=template&id=4549806c"
import script from "./ingredientBreakdown.vue?vue&type=script&lang=js"
export * from "./ingredientBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ingredientBreakdown.vue?vue&type=style&index=0&id=4549806c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports